import { useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";
import BranchesService from "../../../../../services/Company/BranchesService";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const branchesService = new BranchesService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>
				{!!item?.workShifts?.length
					? item?.workShifts?.map((res) => (
							<Badge variant="outline-primary" className="mr-2">
								{res?.name}
							</Badge>
					  ))
					: "-"}
			</td>
			<td>
				<Badge
					className={`text-capitalize ${
						item.openAnyTime ? "text-white" : "text-black"
					}`}
					variant={`${item.openAnyTime ? "primary" : "danger"} light`}>
					{Translate[lang][item?.openAnyTime ? "yes" : "no"]}
				</Badge>
			</td>
			<td>
				{/* {(isExist("edit_job_title") || isExist("delete_job_title")) && ( */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-h" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_job_title") && ( */}
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}>
							<i className="la la-edit"></i> {Translate[lang]?.edit}
						</Dropdown.Item>
						{/* )}
							{isExist("delete_job_title") && ( */}
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							<i className="la la-trash"></i> {Translate[lang]?.delete}
						</Dropdown.Item>
						{/* )} */}
					</Dropdown.Menu>
				</Dropdown>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={branchesService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
const getBackground = (type) => {
	if (type === "orange") {
		return "#FFCABA";
	} else if (type === "yellow") {
		return "#FFDEAD";
	} else if (type === "blue") {
		return "#ECF3FC";
	} else if (type === "red") {
		return "#FFE5EB";
	} else if (type === "green") {
		return "#EFFBF2";
	} else if (type === "gray") {
		return "#F7F7F7";
	} else {
		return "#A1FFF3";
	}
};
export default CardItem;
